<div
  class="flex min-h-[60vh] max-w-[810px] mx-auto items-center justify-center px-4 py-10 border border-[#F3F4F6] shadow-[0px_1.42px_10.65px_#D8D8D826,0px_2.84px_5.68px_-1.42px_#3F3F3F1A]"
>
  <div class="flex w-full px-6 py-10 flex-col items-center text-center">
    <img
      [src]="imageSrc()"
      [alt]="message()"
      class="w-full max-w-[250px] object-contain"
    />

    <h3 class="mb-3 text-2xl leading-8 font-semibol text-gray">
      {{ title() | translate }}
    </h3>
    <p class="mb-14 text-sm leading-[100%] font-medium text-white-darkest">
      {{ message() | translate }}
    </p>

    <div class="flex items-center gap-6">
      <a
        *ngIf="secondaryButtonText() && secondaryButtonLink()"
        [routerLink]="secondaryButtonLink()!"
        (click)="secondaryAction.emit($event)"
        class="inline-flex min-h-12 w-full whitespace-nowrap items-center justify-center rounded-lg bg-transparent px-4 py-3 font-medium text-gray transition hover:bg-white"
      >
        @if (title() === 'Payment confirmed') {
          <sham-i-home-02 />
        }
        {{ secondaryButtonText() | translate }}
      </a>
      <a
        *ngIf="buttonText() && buttonLink()"
        [routerLink]="buttonLink()!"
        (click)="primaryAction.emit($event)"
        class="inline-flex min-h-12 w-full items-center whitespace-nowrap justify-center rounded-lg bg-blue-h px-4 py-3 font-medium text-white transition hover:bg-blue-dark-h"
      >
        {{ buttonText() | translate }}
      </a>
    </div>
  </div>
</div>
